/* src/app/workshop/components/settings/assetcategories/assetcategories.component.scss */
/*# sourceMappingURL=assetcategories.component.css.map */
